/* eslint-disable @typescript-eslint/no-explicit-any */
import {MIN_COTISATION} from '../../../data/constants/Assurance/assuranceRetraite';
import {defaultTelmaErrorValues} from '../../../data/constants/paiement';
import {MESSAGE_VALIDATION} from '../validation';
export const Validation = (contratEC: any, values: any) => {
  let errors: any = {...defaultTelmaErrorValues};

  if (
    contratEC.typePayment === 'cotisation' &&
    contratEC.typeContratPayment === 'retraite'
  ) {
    if (+values.montant.toString().replace(/\s/g, '') < MIN_COTISATION) {
      errors.montant = MESSAGE_VALIDATION.requiredCotisation;
    }
  }

  /** checking all values */

  Object.entries(values).forEach(element => {
    if (element[1] === '' || element[1] === null) {
      if (element[0] !== 'dateEffet')
        errors = {...errors, [element[0]]: MESSAGE_VALIDATION.requiredField};
    }
  });

  return errors;
};
